import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api/public_api';
import { Table } from 'primeng/table';
import { SimuladorService } from 'src/app/datos/simulador.service';
import { FormValidation } from 'src/app/libs/ruvpp-angular2-comun/FormValidation';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { DatosElementoDTO, ElementosDTO, ElementosForm, InputObtenerElementos_Pages, OutputObtenerElementos_Pages } from 'src/app/modelo';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { MenuComponent } from '../menu/menu.component';

@Component({
    selector: 'app-catalogo-elementos',
    templateUrl: './catalogo-elementos.component.html',
    //styleUrls: ['../../../assets/css/styles.css', '../../../assets/css/bootstrap.css']
})
export class CatalogoElementosComponent implements OnInit {

    public datosElementoDTO: DatosElementoDTO;
    public modalTitulo: string;
    public modal: boolean = false;

    @ViewChild('tabla') tabla: Table;
    public isLoading: boolean;
    public elementosDTO: ElementosDTO;
    public filtro: ElementosForm;
    public entidad: ElementosForm;


    //Validaciones

    public Clave_MensajeError: FormValidation = new FormValidation(null);
    public NombreElemento_MensajeError: FormValidation = new FormValidation(null);
    public TipoElemento_MensajeError: FormValidation = new FormValidation(null);
    public TipoDatoEntrada_MensajeError: FormValidation = new FormValidation(null);
    public UnidadMedida_MensajeError: FormValidation = new FormValidation(null);
    public Autoproduccion_MensajeError: FormValidation = new FormValidation(null);
    public Acabado_MensajeError: FormValidation = new FormValidation(null);

    //Menu

    public menu: MenuComponent;

    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: SimuladorService, private _router: Router) {
        this.menu = new MenuComponent(_router);
    }

    /**
     * 
     */
    ngOnInit() {
        this.init();
        this.loading();
    }

    /**
    * 
    */
    private init(): void {
        this.filtro = <ElementosForm>{};
        this.elementosDTO = <ElementosDTO>{ listOutputObtenerElementos: [], totalRecords: 0 };
        this.entidad = <ElementosForm>{};
        this.initValidacion();
    }

    /**
     * 
     */
    private initValidacion(): void {
        this.Clave_MensajeError = new FormValidation(null);
        this.NombreElemento_MensajeError = new FormValidation(null);
        this.TipoElemento_MensajeError = new FormValidation(null);
        this.TipoDatoEntrada_MensajeError = new FormValidation(null);
        this.UnidadMedida_MensajeError = new FormValidation(null);
        this.Autoproduccion_MensajeError = new FormValidation(null);
        this.Acabado_MensajeError = new FormValidation(null);
    }

    /**
     * 
     */
    private loading(): void {
        this.service.ObtenerElementos().subscribe((resultado: JsonResponse<DatosElementoDTO>) => {
            if (resultado != null && resultado.code == 200 && resultado.model != null) {
                this.datosElementoDTO = resultado.model;
                this.setFilter(this.datosElementoDTO, this.filtro);
            }
        });
    }

    /**
     * 
     */
    public nuevoRegistro(): void {

        this.initValidacion();

        this.entidad = <ElementosForm>{};

        this.setFilter(this.datosElementoDTO, this.entidad)

        this.modalTitulo = 'Agregar';

        this.showModalEditar();
    }

    /**
     * 
     * @param entity
     */
    public editar(entity: OutputObtenerElementos_Pages): void {

        this.initValidacion();

        this.entidad = <ElementosForm>{};

        this.setFilter(this.datosElementoDTO, this.entidad)

        this.modalTitulo = 'Editar registro';

        this.entidad.clave = entity.clave;
        this.entidad.nombreElemento = entity.nombreElemento;
        this.entidad.tipoElemento = entity.idtipoElemento;
        this.entidad.tipoDatoEntrada = entity.idTipoDatoEntrada;
        this.entidad.unidadMedida = entity.unidadMedida;
        this.entidad.autoproduccion = entity.esAutoproduccion;
        this.entidad.acabado = entity.esAcabado;

        this.showModalEditar();
    }

    /**
     * 
     */
    public guardar(): void {

        if (!this.validarFormumlario()) {

            //    let entity: InputAgregarManoObra = <InputAgregarManoObra>{
            //        idTipoElemento: this.entidad.categoria,
            //        nombreElemento: this.entidad.nombreElemento,
            //        idElemento: this.entidad.elemento,
            //        unidadMedida: this.entidad.unidadMedida,
            //        idPersonalUtilizar: this.entidad.personalUtilizar,
            //        rendimientoxSemana: this.entidad.rendimientoSemana,
            //        salarioSemanal: this.entidad.costoSemana,
            //        volumenEjecutar: this.entidad.volumenEjecutar,
            //        clave: this.entidad.clave,
            //        idTipoDatoEntrada: this.entidad.tipoDatoEntrada,
            //        esAutoproduccion: this.entidad.esAutoproduccion,
            //        idTipoManoObra: this.entidad.tipoManoObra
            //    };

            //    this.service.AgregarManoObra(entity).subscribe((resultado: JsonResponse<number>) => {

            //        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            //            this.closeModal();

            //            this.servicioAlertas.mostrarConOpciones({
            //                title: "Simulador RUV",
            //                text: `El registro se guardó con éxito.`,
            //                icon: "success",
            //                showCancelButton: false,
            //                confirmButtonColor: '#3085d6',
            //                cancelButtonColor: '#3085d6',
            //                confirmButtonText: 'Aceptar',
            //                cancelButtonText: 'Cancelar'
            //            }).then((result) => {

            //                console.log('result.value -->> ', result.value)

            //                if (result.value) {
            //                    console.log('true')
            //                } else {

            //                    if (result.dismiss === Swal.DismissReason.cancel) {
            //                        console.log('false')
            //                    }
            //                }

            //            })

            //        }
            //    });

        }
    }

    /**
     * 
     * @param entity
     */
    public eliminar(entity: OutputObtenerElementos_Pages): void {

        this.servicioAlertas.mostrarConOpciones({
            title: "Simulador RUV",
            html: `&#160;<br/>Está seguro que desea eliminar el registro <b> <br>"${entity.nombreElemento}"</b><br/>&#160;`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {

            console.log('result.value -->> ', result.value)

            if (result.value) {

                console.log('true')

                {

                    this.servicioAlertas.mostrarConOpciones({
                        title: "Simulador RUV",
                        text: `El registro se eliminó con éxito.`,
                        icon: "success",
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {

                        console.log('result.value -->> ', result.value)

                        if (result.value) {
                            console.log('true')
                        } else {

                            if (result.dismiss === Swal.DismissReason.cancel) {
                                console.log('false')
                            }
                        }

                    })

                }


            } else {

                if (result.dismiss === Swal.DismissReason.cancel) {
                    console.log('false')
                }
            }

        })

    }

    /**
    * 
    * @param tipo
    */
    public actualizarErrores(tipo: string) {

        switch (tipo) {
            case 'Clave':
                this.Clave_MensajeError = new FormValidation(this.entidad.clave).requered('La clave es obligatoria.');
                break;
            case 'NombreElemento':
                this.NombreElemento_MensajeError = new FormValidation(this.entidad.nombreElemento).requered('El nombre del elemento es obligatorio.');
                break;
            case 'TipoElemento':
                this.TipoElemento_MensajeError = new FormValidation(this.entidad.tipoElemento).requered('El tipo de elemento es obligatorio.');
                break;
            case 'TipoDatoEntrada':
                this.TipoDatoEntrada_MensajeError = new FormValidation(this.entidad.tipoDatoEntrada).requered('El tipo de dato de entrada es obligatorio.');
                break;
            case 'UnidadMedida':
                this.UnidadMedida_MensajeError = new FormValidation(this.entidad.unidadMedida).requered('La unidad de medida es obligatoria.');
                break;
            case 'Autoproduccion':
                this.Autoproduccion_MensajeError = new FormValidation(this.entidad.autoproduccion).requered('La autoproducción es obligatoria.');
                break;
            case 'Acabado':
                this.Acabado_MensajeError = new FormValidation(this.entidad.acabado).requered('El acabado es obligatoria.');
                break;

        }

    }

    /**
     * 
     */
    public validarFormumlario(): boolean {

        var error = false;

        this.Clave_MensajeError = new FormValidation(this.entidad.clave).requered('La clave es obligatoria.');

        if (this.Clave_MensajeError.error) {
            error = true;
        }

        this.NombreElemento_MensajeError = new FormValidation(this.entidad.nombreElemento).requered('El nombre del elemento es obligatorio.');

        if (this.NombreElemento_MensajeError.error) {
            error = true;
        }

        this.TipoElemento_MensajeError = new FormValidation(this.entidad.tipoElemento).requered('El tipo de elemento es obligatorio.');

        if (this.TipoElemento_MensajeError.error) {
            error = true;
        }

        this.TipoDatoEntrada_MensajeError = new FormValidation(this.entidad.tipoDatoEntrada).requered('El tipo de dato de entrada es obligatorio.');

        if (this.TipoDatoEntrada_MensajeError.error) {
            error = true;
        }

        this.UnidadMedida_MensajeError = new FormValidation(this.entidad.unidadMedida).requered('La unidad de medida es obligatoria.');

        if (this.UnidadMedida_MensajeError.error) {
            error = true;
        }

        this.Autoproduccion_MensajeError = new FormValidation(this.entidad.autoproduccion).requered('La autoproducción es obligatoria.');

        if (this.Autoproduccion_MensajeError.error) {
            error = true;
        }

        this.Acabado_MensajeError = new FormValidation(this.entidad.acabado).requered('El acabado es obligatoria.');

        if (this.Acabado_MensajeError.error) {
            error = true;
        }

        return error;
    }

    /**
     * 
     */
    public closeModal(): void {
        this.modal = false;
    }

    /**
     * 
     */
    public showModalEditar(): void {
        this.modal = true;
    }

    /**
     * 
     * @param entity
     * @param form
     */
    private setFilter(entity: DatosElementoDTO, form: ElementosForm): void {

        let lista: any = [{ label: 'Si', value: true }, { label: 'No', value: false }];

        form.listAcabado = lista;
        form.listAutoproduccion = lista;
        form.listTipoDatoEntrada = entity.listTipoDatoEntrada;
        form.listTipoElemento = entity.listTipoElementos;
        form.listUnidadMedida = entity.listUnidadMedida;
    }

    /**
     * 
     */
    public Limpiar(): void {
        this.init();
        this.setFilter(this.datosElementoDTO, this.filtro);
        this.Filtrar();
        this.tabla._rows = 10;
    }

    /**
     * 
     */
    public Filtrar(): void {
        this.loadCarsLazy(null);
    }

    /**
     * 
     * @param event
     */
    public loadCarsLazy(event: LazyLoadEvent) {

        this.isLoading = true;

        //in a real application, make a remote request to load data using state metadata from event
        //event.first = First row offset
        //event.rows = Number of rows per page
        //event.sortField = Field name to sort with
        //event.sortOrder = Sort order as number, 1 for asc and -1 for dec
        //filters: FilterMetadata object having field as key and filter value, filter matchMode as value

        //imitate db connection over a network

        console.log('event -->> ', event);

        let page: number = 1;
        let tamanioPagina = 10;

        if (event != null && event.first != null) {
            page = (event.first + event.rows) / event.rows;
            tamanioPagina = event.rows;
        }

        let data: InputObtenerElementos_Pages = <InputObtenerElementos_Pages>{
            tamanioPagina: tamanioPagina,
            pagina: page,
            clave: this.filtro.clave,
            nombreElemento: this.filtro.nombreElemento,
            idTipoElemento: this.filtro.tipoElemento,
            idTipoDatoEntrada: this.filtro.tipoDatoEntrada,
            unidadMedida: this.filtro.unidadMedida,
            esAutoproduccion: this.filtro.autoproduccion,
            esAcabado: this.filtro.acabado,
        };

        setTimeout(() => {

            this.service.ObtenerElementosPages(data).subscribe((resultado: JsonResponse<ElementosDTO>) => {

                if (resultado != null && resultado.code == 200 && resultado.model != null) {
                    this.elementosDTO = resultado.model;
                }

                this.isLoading = false;
            });

        }, 1000);
    }

}

